import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthorizationService, private router: Router, private alertService: HttpAlertService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
              if (this.router.url !== '/login' && this.router.url !== '/reset' &&  this.router.url !== '/resetPass') {
               this.authenticationService.logout();
               this.alertService.error('system_unauthorized_request_title', '', true);
               
                //sprawdzic 
              }
 
            } else if (err.status === 500) {
                this.alertService.error('system_internal_error', '', true);

            }
            const error = err || err.statusText;
            return throwError(error);
        }));
    }
}
